// extracted by mini-css-extract-plugin
export default {"link":"al7gWrJrBvCvbeI_AGcX"};